"use client";

// „Neue Nachricht“ — und daneben derselbe Weg mit einer Vorlage.
import Link from "next/link";
import { useRouter } from "next/navigation";
import { ChevronDown, Plus } from "lucide-react";
import { Button, buttonVariants } from "@/components/ui/button";
import { DropdownItem, DropdownLabel, DropdownMenu, DropdownSeparator } from "@/components/ui/dropdown-menu";
import { TEMPLATE_KIND } from "@/lib/labels";
import type { TemplateKind } from "@/generated/prisma/enums";

export function NeueNachrichtKnopf({ vorlagen }: { vorlagen: { id: string; name: string; kind: TemplateKind }[] }) {
  const router = useRouter();
  return (
    <div className="flex items-center gap-2">
      {vorlagen.length > 0 && (
        <DropdownMenu
          trigger={
            <Button variant="outline">
              Aus Vorlage
              <ChevronDown className="text-text-tertiary h-3.5 w-3.5" aria-hidden />
            </Button>
          }
        >
          <DropdownLabel>Vorlage wählen</DropdownLabel>
          {vorlagen.map((v) => (
            <DropdownItem key={v.id} onClick={() => router.push(`/nachrichten/neu?vorlage=${v.id}`)}>
              <span className="min-w-0 flex-1 truncate">{v.name}</span>
              <span className="text-caption text-text-tertiary shrink-0">{TEMPLATE_KIND[v.kind]}</span>
            </DropdownItem>
          ))}
          <DropdownSeparator />
          <DropdownItem onClick={() => router.push("/nachrichten/vorlagen")}>Vorlagen verwalten</DropdownItem>
        </DropdownMenu>
      )}
      <Link href="/nachrichten/neu" className={buttonVariants()}>
        <Plus className="h-4 w-4" aria-hidden />
        Neue Nachricht
      </Link>
    </div>
  );
}
